"use client"
import React from "react"
import { Link, useLocation } from "react-router-dom"
import ThemeToggle from "./ThemeToggle"

export default function Header() {
  const { pathname } = useLocation()

  return (
    <header className="fixed top-0 left-0 right-0 z-40 bg-white/80 dark:bg-gray-900/80 backdrop-blur border-b border-gray-200 dark:border-gray-800">
      <div className="max-w-7xl mx-auto h-12 px-4 flex items-center justify-between">
        <div className="flex items-center gap-4">
          {/* Light logo */}
          <Link className={linkCls(pathname === "/")} to="/">
          <img
            src="/logo-light.png"
            alt="PG-HIVE Logo"
            className="h-7 block dark:hidden transition-opacity"
          />
          {/* Dark logo */}
          <img
            src="/logo-dark.png"
            alt="PG-HIVE Logo"
            className="h-7 hidden dark:block transition-opacity"
          />
          </Link>

          <nav className="hidden sm:flex items-center gap-3 text-sm">
            <Link className={linkCls(pathname === "/dashboard")} to="/dashboard">Dashboard</Link>
            <Link className={linkCls(pathname === "/CreateSchema")} to="/CreateSchema">Create Schema</Link>
            <Link className={linkCls(pathname === "/about")} to="/about">About</Link>
          </nav>
        </div>
        <ThemeToggle />
      </div>
    </header>
  )
}

function linkCls(active) {
  return [
    "px-2 py-1 rounded transition-colors",
    active
      ? "bg-blue-50 text-blue-700 dark:bg-blue-900/30 dark:text-blue-200"
      : "text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-800"
  ].join(" ")
}
